import { Button, ListGroup } from "react-bootstrap";
import { ExepnditureAccordion, ExepnditureAccordionBody, ExepnditureAccordionCollapseSection, ExepnditureAccordionToggle } from "../expenditureaccordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPlus, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import styles from '../../../../../styles/expenditureworksheet.module.css';
import useTestExpenditureData from "../../../../../testdata/expenditure/testexpenditurestore";
import formatDollars from "../../../../../utilities/currency-formatter";
import DeleteButtonNonNetwork from "../../../../../components/deletebuttonnonnetwork";
import moment from "moment";
import DeleteButton from "../../../../../components/deletebutton";
import useMessageStore from "../../../../../stores/message-store";

const ExpenditureRefund = ({ApplicationID, toggleAddEditMode, addEditIndex, refunds = [], refresh, checkTypeMap, canAdd = false, canUpdate = false, canDelete = false }) => {

    const _getExpenditureCheckTypeText = (expenditureTypeId) => {
        if(expenditureTypeId === null)
            return <span>Type Missing</span>
        else
            return <span>{checkTypeMap[expenditureTypeId]}</span>
    }

    const addToast = useMessageStore(state => state.addToast);
    
    const _deleteSuccessCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "The Refund entry was succesfully deleted!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )
    
        refresh();
    }

    const _deleteErrorCallback = () => {
        addToast(
            {
                id: Math.random(),
                body: "An error occured when deleting the Refund entry.",
                autoHide: true,
                errorFlag: true,
                timestamp: Date.now() - 1000
            }
        )
    }


    const refundTotal = refunds.reduce((acc,item) => acc + item.amount,0);
    const showEmptyState = !canAdd && refunds.length === 0;

    return (
        <ExepnditureAccordion>
            <ExepnditureAccordionBody eventKey='0'>
                <ExepnditureAccordionToggle eventKey='0'>
                    <span className='d-flex justify-content-between align-items-center w-100'>
                        <span className='fw-bold'>REFUND</span>
                        <span>{formatDollars(refundTotal)}</span>
                    </span>
                </ExepnditureAccordionToggle>
                <ExepnditureAccordionCollapseSection>
                    <ListGroup>
                        {
                            canAdd
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem}`}>
                                    <div className='d-flex justify-content-center'>
                                        <Button type='button' variant='success' size='sm' title="Add Refund Entry" aria-label="Add Refund Entry" style={{ borderRadius: '50%' }} onClick={() => toggleAddEditMode(null, addEditIndex, 'add')}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            showEmptyState
                            ?
                                <ListGroup.Item className={`${styles.expenditureListItem} text-center text-muted`}>
                                    No refund entries to display.
                                </ListGroup.Item>
                            :
                                null
                        }
                        {
                            refunds.map(refund => {

                                return (
                                    <ListGroup.Item key={refund.id} className={`${styles.expenditureListItem}`}>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{formatDollars(refund.amount)}</span>
                                            <span>{refund.createddate}</span>
                                        </div>
                                        <div className={styles.expenditureListItemText}>
                                            {refund.itempurpose}
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span className={styles.expenditureListItemType}>
                                                CHECK TYPE: { _getExpenditureCheckTypeText(refund.expendituretypeid)}
                                            </span>
                                            <span className='d-flex'>
                                                <div>
                                                    <Button size="sm" type="button" variant="primary" className="me-1" title={canUpdate ? "Edit Refund Entry" : "View Refund Entry"} aria-label={canUpdate ? "Edit Refund Entry" : "View Refund Entry"} onClick={() => toggleAddEditMode(refund.id, addEditIndex, canUpdate ? 'edit' : 'view')}>
                                                        <FontAwesomeIcon icon={canUpdate ? faPenToSquare : faEye} />
                                                    </Button>
                                                </div>
                                                {
                                                    canDelete
                                                    ?
                                                        <div >
                                                            <DeleteButton
                                                                deleteObject={{ApplicationID: ApplicationID,RefundID: refund.id}}
                                                                endpoint="ExpenditureWorksheet_Refund_Delete"
                                                                successCallback={_deleteSuccessCallback}
                                                                errorCallback={_deleteErrorCallback}
                                                            />
                                                        </div>
                                                    :
                                                        null
                                                }
                                            </span>
                                        </div>
                                    </ListGroup.Item>
                                );
                            })
                        }

                    </ListGroup>
                </ExepnditureAccordionCollapseSection>
            </ExepnditureAccordionBody>
        </ExepnditureAccordion>
    )
}

export default ExpenditureRefund;
